import React from 'react';
import { getChangePageThreshold } from "./page.utils";
export const useIoConfig = (layoutDim, scale, rotation, dims) => {
  const changePageThreshold = React.useMemo(() => getChangePageThreshold(layoutDim, scale, rotation, dims), [scale, rotation, dims, layoutDim]);
  const ioConfig = React.useMemo(() => {
    const threshold = [0, changePageThreshold];
    return {
      threshold
      // root: // TODO should be the scrollable container ?
    };
  }, [changePageThreshold]);
  return {
    ioConfig,
    changePageThreshold
  };
};